var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgHtlStageOutlined = function SvgHtlStageOutlined(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "1em",
    height: "1em",
    fill: "none",
    viewBox: "0 0 16 16"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M10.828 14.031a.5.5 0 0 1-.175-.031H3a1 1 0 0 1-1-1V3a1 1 0 0 1 1-1h10a1 1 0 0 1 1 1v10a1 1 0 0 1-1 1h-2a.5.5 0 0 1-.161.031h-.011ZM13 13V9.344A3.3 3.3 0 0 1 12.2 9a9.536 9.536 0 0 0-.879 4H13Zm-2.675 0c-.01-1.611.36-3.202 1.082-4.643a5.899 5.899 0 0 1-1.171-1.922A11.47 11.47 0 0 1 9.514 3H6.487a11.5 11.5 0 0 1-.675 3.427 5.779 5.779 0 0 1-1.191 1.96 15.968 15.968 0 0 1 1.168 4.612l4.536.001ZM3 13h1.787a14.924 14.924 0 0 0-.982-3.958c-.253.15-.523.27-.805.354V13Zm0-4.666c2.02-.868 2.408-4.079 2.483-5.333H3v5.333Zm10-.047V3h-2.481c.103 1.559.676 4.518 2.481 5.286v.001Z"
  })));
};
export default SvgHtlStageOutlined;